/* USF file - Do not modify this file since it is regularly changed. Auto modified at: 10/12/2021 7:20:29 AM*/
!(function () {
    function e(e) {
        return "[object Function]" === Object.prototype.toString.call(e);
    }
    function t(e) {
        return "string" == typeof e || e instanceof String;
    }
    function r(r) {
        var n;
        r = { config: r }.config;
        var s = new XMLHttpRequest(),
            i = r.type || "GET",
            a =
                "GET" === i
                    ? (function (r) {
                          var n,
                              s,
                              i = r.data;
                          if (!i) return r.url;
                          if ((e(i) && (i = i()), !t(i))) {
                              var a = [];
                              for (var o in i) a.push(o + "=" + encodeURIComponent(i[o]));
                              i = a.join("&");
                          }
                          return (n = r.url), (s = i) ? (n.includes("?") ? n + "&" + s : n + "?" + s) : n;
                      })(r)
                    : r.url;
        s.open(i, a, !0), (s.timeout = r.timeout), s.setRequestHeader("Content-Type", r.contentType || "application/x-www-form-urlencoded");
        var o = r.error,
            l = !1,
            u = !1,
            c = {
                abort: function () {
                    (l = !0), (u = !0), s.abort(), r.abort && r.abort.apply(r, [s]);
                },
            };
        (s.onreadystatechange = function () {
            4 == s.readyState &&
                (s.status >= 200 && s.status < 400
                    ? r.success &&
                      r.success.apply(r, [
                          (function (e, t) {
                              switch (e.dataType) {
                                  case "json":
                                      return JSON.parse(t.responseText);
                                  default:
                                      return t.responseText;
                              }
                          })(r, s),
                          {
                              xhr: s,
                              redirected: (function (e, t) {
                                  for (var r = 0, n = t.response; r < n.length; ) {
                                      var s = n[r++];
                                      if ("\t" !== s && " " !== s && "\r" !== s && "\n" !== s) return "<" === s && -1 !== n.indexOf("<html");
                                  }
                              })(0, s),
                              config: r,
                          },
                      ])
                    : o && !l && ((l = !0), o.apply(r, [s, s.status, null, { xhr: s, config: r }])));
        }),
            (s.onerror = function (e) {
                o && !l && ((l = !0), o.apply(r, [s, s.status, e]));
            }),
            (s.ontimeout = function (e) {
                o && !l && ((l = !0), o.apply(r, [s, "timeout", e]));
            }),
            (s.onabort = function (e) {
                u || ((l = !0), (u = !0), r.abort && r.abort.apply(r, [s]));
            });
        var f = r.data;
        e(f) && (f = f());
        try {
            s.send(f);
        } catch (n) {
            o && !l && ((l = !0), o.apply(r, [s, s.status, n]));
        }
        return c;
    }
    var n,
        s = function () {
            this.list = {};
        };
    (s.prototype = {
        add(e, t) {
            if (Array.isArray(e)) for (var r = e.length, n = 0; n < r; n++) this.add(e[n], t);
            else {
                var s = this.list[e];
                s || (this.list[e] = s = []), s.push(t);
            }
        },
        remove(e, t) {
            t || delete this.list[e];
            var r = this.list[e];
            r.splice(r.indexOf(t), 1);
        },
        raise(e, t, r) {
            if (window.usf_container || "rerender" !== e) {
                var n = this.list[e];
                if (n) for (var s = 0; s < n.length; s++) n[s](t, r);
                else;
            }
        },
    }),
        window.usf || (window.usf = {}),
        (usf.components = {}),
        (usf.collectionsByUrlName = {}),
        (usf.EventHub = s),
        (usf.event = n = new s());
    var i = (usf.settings = {
        online: 1,
        version: "1.0.2.4112",
        storeId: "tvo-ilc-international.myshopify.com",
        siteId: "1b1826a4-d9b6-46f7-8d7f-4b0f8123e1b2",
        resUrl: "//cdn.shopify.com/s/files/1/0257/0108/9360/t/85/assets/",
        analyticsApiUrl: "https://analytics-usf.hotyon.com/set",
        searchSvcUrl: "https://svc-0-usf.hotyon.com/",
        enabledPlugins: ["addtocart-usf", "lang-weglot", "review-shopify", "wishlist-wishlistplus"],
        currency: "CAD",
        priceLongFormat: "${0}",
        priceFormat: "${0}",
        showGotoTop: 1,
        mobileBreakpoint: 1025,
        decimals: 2,
        decimalDisplay: ".",
        thousandSeparator: ",",
        plugins: {},
        revision: 23017035,
        searchSvcUrl: "https://svc-0-usf.hotyon.com/",
        filters: {},
        instantSearch: { searchBoxSelector: "input[name=q]", numOfSuggestions: 6, numOfProductMatches: 4, numOfCollections: 3, numOfPages: 3 },
        search: {
            sortFields: ["", "title", "-title"],
            searchResultsUrl: "/pages/search-results",
            more: "more",
            itemsPerPage: 27,
            imageSizeType: "fixed",
            imageSize: "600,350",
            showSearchInputOnSearchPage: 1,
            showSearchInputOnCollectionPage: 1,
            canChangeUrl: 1,
        },
        collections: { online: 1, collectionsPageUrl: "/pages/collections" },
        filterNavigation: { showFilterArea: 1 },
        translation_en: {
							 
											  
												
            viewAllResultsFor: "view all results for <span class=\u0022usf-highlight\u0022>{0}</span>",
            viewAllResults: "view all results",
            noMatchesFoundFor: "Sorry, we couldn\u0027t not find any results for  \u0022<b>{0}</b>\u0022. Please try again with a different term.",
            productSearchResultWithTermSummary: "Showing results for \u0027<b>{1}</b>\u0027",
            productSearchResultSummary: "<b>{0}</b> products",
            productSearchNoResults: "<h2>Sorry, we couldn\u0027t find any results for   \u0027<b>{0}</b>\u0027.</h2><p>Try again using more general search terms.</p>",
            productSearchNoResultsEmptyTerm: "<h2>No results found.</h2><p>But don\u0027t give up – check the filters or try less specific terms.</p>",
            clearAll: "Clear all",
            clear: "Clear",
            clearAllFilters: "Clear all filters",
            clearFiltersBy: "Clear filters by {0}",
            filterBy: "Filter by {0}",
            sort: "Sort",
            sortBy_r: "Relevance",
            sortBy_title: "Title: A-Z",
            "sortBy_-title": "Title: Z-A",
            sortBy_date: "Date: Old to New",
            "sortBy_-date": "Date: New to Old",
            sortBy_price: "Price: Low to High",
            "sortBy_-price": "Price: High to Low",
            "sortBy_-discount": "Discount: High to Low",
            sortBy_bestselling: "Bestselling",
            "sortBy_-available": "Inventory: High to Low",
            filters: "Filter Search",
            filterOptions: "Filter options",
            clearFilterOptions: "Clear all filter options",
            youHaveViewed: "You\u0027ve viewed {0} of {1} products",
            loadMore: "Show More Courses",
									  
            productMatches: "Product matches",
								 
																												   
            searchSuggestions: "Search suggestions",
            quantity: "Quantity",
            selectedVariantNotAvailable: "The selected variant is not available.",
            addToCart: "Add Course",
            seeFullDetails: "See full details",
            chooseOptions: "Choose options",
            quickView: "Quick view",
            sale: "Sale",
            save: "Save",
            soldOut: "Sold out",
            viewItems: "Done",
            more: "More",
            all: "All",
            prevPage: "Previous page",
            gotoPage: "Go to page {0}",
            nextPage: "Next page",
            from: "From",
            collections: "Collections",
            pages: "Pages",
            sortBy_: "Relevance",
            "sortBy_metafield:course.grade": "course.grade: A-Z",
            "sortBy_-metafield:course.grade": "course.grade: Z-A",
            "sortBy_metafield:course.subject": "course.subject: A-Z",
            "sortBy_-metafield:course.subject": "course.subject: Z-A",
            "sortBy_metafield:course.language": "course.language: A-Z",
            "sortBy_-metafield:course.language": "course.language: Z-A",
            "sortBy_metafield:course.course_type": "course.course_type: A-Z",
            "sortBy_-metafield:course.course_type": "course.course_type: Z-A",
            "sortBy_metafield:course.course_title": "course.course_title: A-Z",
            "sortBy_-metafield:course.course_title": "course.course_title: Z-A",
            "sortBy_metafield:course.course_code": "course.course_code: A-Z",
            "sortBy_-metafield:course.course_code": "course.course_code: Z-A",
            "sortBy_option:Location": "Location: A-Z",
            "sortBy_-option:Location": "Location: Z-A",
            "sortBy_option:Title": "Title: A-Z",
            "sortBy_-option:Title": "Title: Z-A",
            "sortBy_metafield:course.": "course.: A-Z",
            "sortBy_-metafield:course.": "course.: Z-A",
        },
    });
    i.currencyRate = 1;
    var a,
        o,
        l = function (e) {
            if (((this.list = []), e)) for (var t = 0; t < e.length; t++) this.push(e[t]);
            var r = this,
                n = !1;
            function s() {
                if (!n) {
                    var e = i.analyticsApiUrl;
                    if (void 0 !== navigator.sendBeacon) {
                        var t = navigator.sendBeacon(e, JSON.stringify({ events: r.list, time: new Date() }));
                        n = t;
                    } else {
                        var s = "events=" + encodeURIComponent(JSON.stringify(r.list)) + "&time=" + new Date().toISOString(),
                            a = new XMLHttpRequest();
                        a.open("POST", e, !1), a.setRequestHeader("Content-Type", "text/plain;charset=UTF-8"), a.send(s);
                    }
                }
            }
            window.addEventListener("beforeunload", s), window.addEventListener("unload", s);
        };
    (l.prototype = {
        push(e) {
            "function" == typeof e && (e = e.apply(this)), e.length && this[e[0]].apply(this, e.slice(1, e.length)), this.list.push(e);
        },
        track(e, t) {
            (t.event = e), (t.siteId = i.siteId), (t.time = new Date()), this.list.push(t);
        },
    }),
        (window._usfaq = new l(window._usfaq));
    var u,
        c,
        f,
        d,
        h,
        p,
        g = { List: 0, Box: 1, Swatch: 2 };
    function m(e) {
        if (e && !c) {
            var t = document.createElement("div");
            (t.innerHTML = e), usf_container.parentNode.insertBefore(t, usf_container), (c = 1), b.redirectToOriginalView();
        }
    }
    function y(e, t, r) {
        function s(s) {
            if (r)
                if (u) {
                    var i = u;
                    (u = s), i();
                } else u = s;
            else {
                (a = null), (e.loader = !1), (s = JSON.parse(s)), n.raise("sr_dataReceived", this, s.data);
                var o = s.data.redirect;
                o && e.onRedirect(o), t && e.result && f ? (e.result.items = e.result.items.concat(s.data.items)) : (e.result = s.data);
                var l = s.data.facets;
                if (((e.hasFacets = l && l.length), e.hasFacets)) {
                    for (var c = !1, d = 0; d < l.length; d++) {
                        var h = l[d];
                        (h.labels.length || void 0 !== h.min || (h.navigationCollectionsKeepMain && h.navigationCollectionsMenu.length)) && (c = !0), (h.displayMode = g[h.display]);
                    }
                    c || (e.hasFacets = !1);
                }
                e.itemsLoaded += s.data.items.length;
                var p = s.data.extra;
                if (p) {
                    var v = p.collections;
                    if (v) {
                        var y = (usf.collectionsByUrlName = {});
                        for (d = 0; d < v.length; d++) {
                            var _ = v[d];
                            y[_.urlName] = _;
                        }
                    }
                    m(p.message);
                }
                document.body.classList[e.noFacets ? "add" : "remove"]("usf-has-no-facets"),
                    e.$nextTick &&
                        e.$nextTick(() => {
                            n.raise("sr_updated", this, s.data);
                        });
            }
        }
        if (r) u = null;
        else if (void 0 !== u) {
            function l() {
                s(u), (u = void 0);
            }
            return void (null === u ? (u = l) : l());
        }
        var c = i.search.more,
            f = "more" === c || "infinite" === c,
            d = { q: _(e.term), apiKey: i.siteId, locale: b.locale };
        window._usfGetProductDescription || (d.getProductDescription = 0);
        var h = b.customerTags;
        h && h.length && (d.customerTags = h.join(","));
        var p,
            v,
            y = e.facetFilters,
            w = { query: d, filters: y };
        b.onSearch(w),
            (y = w.filters) && (d.facetFilters = JSON.stringify(y)),
            f ? ((p = e.itemsLoaded), (v = e.take - p)) : ((p = (e.page - 1) * e.itemsPerPage), (v = e.itemsPerPage)),
            (d.skip = p),
            (d.take = v),
            e.sortBy && "r" !== e.sortBy && (d.sort = e.sortBy),
            e.itemsLoaded || o === e.term || ((o = e.term), e.term && _usfaq.track("search", { term: e.term, isEmpty: e.result && !e.result.items.length })),
            a && a.abort(),
            (a = usf.utils.send({
                url: i.searchSvcUrl + "search",
                data: d,
                startTime: e._refreshTime,
                success: s,
                error: function (r, n, s) {
                    403 !== n
                        ? setTimeout(() => {
                              u = void 0;
                              var r = usf.search;
                              (r._refreshTime = e._refreshTime), r.refresh(t);
                          }, 3e3)
                        : m(JSON.parse(r.response).meta.description);
                },
            }));
    }
    function _(e) {
        for (var t = 0; t < e.length && " " === e[t]; ) t++;
        return t > 0 && (e = e.substr(t)), e.toLocaleLowerCase().replace(/[*\?]/g, "");
    }
    usf._refineTerm = _;
    var w = location.pathname.toLowerCase();
    usf.platform = {
        name: "shopify",
        termVar: "q",
        isCollectionPage: -1 !== w.indexOf("/collections/") && -1 === w.indexOf("/products/"),
        get collection() {
            if (h) return h;
            var e = b.collectionWithParams;
            if (e) {
                var t = e.lastIndexOf("/");
                -1 !== t && (e = e.substring(0, t)), (h = e);
            }
            return e;
        },
        set collection(e) {
            h = e;
        },
        get locale() {
            if (!f) {
                var e = w,
                    t = e.indexOf("/collections/");
                -1 === t && (t = e.endsWith("/search") ? e.length - 7 : e.indexOf("/pages/")), (f = t > 0 ? e.substring(1, t).replace(/[\/\\]/g, "_") : Shopify.locale.toLowerCase());
            }
            return f;
        },
        get baseUrl() {
            if (void 0 === d) {
                var e = w,
                    t = "/" + b.locale;
                e.startsWith(t) || (t = ""), (d = t);
            }
            return d;
        },
        get collectionWithParams() {
            var e = w,
                t = b.baseUrl;
            if (e.startsWith(t + "/collections/")) return decodeURIComponent(e.substring(t.length + 13));
        },
        get tagUrlName() {
            if (void 0 === p) {
                var e = b.collectionWithParams;
                if (e) {
                    var t = e.lastIndexOf("/");
                    p = -1 !== t ? e.substring(t + 1) : null;
                }
            }
            return p;
        },
        get customerTags() {
            return _usfCustomerTags;
        },
        onSearch(e) {
            if ("vendors" === b.collection) {
                var t = V.get("q");
                t && ((e.query.q = ""), e.filters || (e.filters = {}), (e.filters._usf_vendor = ["vendor", [t]]));
            }
            var r = _usfCollectionId || "",
                n = b.tagUrlName;
            n && (r += "/" + n), (r || b.isCollectionPage) && (e.query.collection = r);
        },
        init() {
            _usfTheme.applied && (i.search.searchResultsUrl = "/search");
        },
        redirectToOriginalView() {
            var e = location.href;
            -1 === e.indexOf("no-usf") && (location = e + (-1 === e.indexOf("?") ? "?" : "&") + "view=no-usf");
        },
    };
    var b = usf.platform;
    const S = "_usf_";
    var k = function (e) {
        (this.canChangeUrl = e), (this.changed = []);
        var t = this;
        function r() {
            t.changed.forEach((e) => e());
        }
        (history.pushState = ((e) =>
            function () {
                var t = e.apply(this, arguments);
                return r(), t;
            })(history.pushState)),
            (history.replaceState = ((e) =>
                function () {
                    var t = e.apply(this, arguments);
                    return r(), t;
                })(history.replaceState)),
            window.addEventListener("popstate", () => {
                r();
            });
    };
    function C(e) {
        return (e = e.replace(/\+/g, " ")), decodeURIComponent(e);
    }
    var E = function (e) {
        for (var t = e ? e.substring(1).split("&") : [], r = [], n = 0; n < t.length; n++) {
            var s = t[n].split("="),
                i = s[1];
            if (void 0 !== i) {
                var a,
                    o = i.split(S);
                (a = o.length > 1 ? o.map((e) => C(e)) : C(i)), r.push([C(s[0]), a]);
            }
        }
        this.entries = r;
    };
    E.prototype = {
        get(e, t) {
            var r = this.entries.find((t) => t[0] === e);
            return r ? r[1] : t;
        },
        append(e, t) {
            this.entries.find((r) => r[0] === e && r[1] === t) || this.entries.push([e, t]);
        },
        set(e, t) {
            var r = this.entries.find((t) => t[0] === e);
            r ? (r[1] = t) : this.entries.push([e, t]);
        },
        toString() {
            var e,
                t = this.entries.map((t) => encodeURIComponent(t[0]) + "=" + ((e = t[1]), Array.isArray(e) ? e.map((e) => encodeURIComponent(e)).join(S) : encodeURIComponent(e))).join("&");
            return t ? "?" + t : "";
        },
        delete(e, t) {
            for (var r = this.entries.length - 1; r >= 0; r--) {
                var n = this.entries[r];
                P(e, decodeURIComponent(n[0])) && ((t && decodeURIComponent(n[1]) !== t) || this.entries.splice(r, 1));
            }
        },
    };
    var T = location.search;
    function U(e, t, r, n) {
        if (!1 !== r) {
            if (n.canChangeUrl) {
                var s = C(location.search) !== C(e);
                return r || s ? ((e = location.pathname + e), t || !s ? history.replaceState(null, null, e) : history.pushState(null, null, e), !0) : void 0;
            }
            e !== T && ((T = e), n.changed.forEach((e) => e()));
        }
    }
    function P(e, r) {
        return t(e) ? e === r : e.test(r);
    }
    function O(e, t, r) {
        Object.keys(t).forEach((n) => {
            (function (t, r) {
                for (var n = 0; n < e.entries; n++) {
                    var s = e.entries[n];
                    if (s[0] === t && s[1] === r) return !0;
                }
            })(n, t[n]) || e[r.append ? "append" : "set"](n, t[n]);
        });
    }
    (k.prototype = {
        get(e, t) {
            return new E(this.getSearch()).get(e, t);
        },
        entries() {
            return new E(this.getSearch()).entries;
        },
        snapshot() {
            this._snapshot = this.entries();
        },
        getSearch() {
            return this.canChangeUrl ? location.search : T;
        },
        getChanges() {
            var e = this.entries(),
                t = this._snapshot;
            if (!t) return e;
            var r = [];
            return (
                e.forEach((e) => {
                    t.find((t) => t[0] === e[0] && t[1] === e[1]) || r.push(e);
                }),
                t.forEach((t) => {
                    e.find((e) => e[0] === t[0]) || r.push([t[0]]);
                }),
                r
            );
        },
        update(e, t, r) {
            var n = new E(this.getSearch());
            if ((r || (r = {}), t))
                if (t.length) t.forEach((e) => n.delete(e));
                else
                    for (var s = n.entries.length - 1; s >= 0; s--) {
                        var i = n.entries[s],
                            a = i[0];
                        if (t.hasOwnProperty(a)) {
                            var o = t[a];
                            i[1] === o && n.delete(a, o);
                        }
                    }
            return e && O(n, e, r), U(n.toString(), r.replace, r.force, this);
        },
        add(e, t) {
            var r = new E(this.getSearch());
            return t || (t = {}), O(r, e, t), U(r.toString(), t.replace, t.force, this);
        },
        remove(e) {
            var r,
                n = new E(this.getSearch()),
                s = arguments.length;
            if ((s >= 2 && "object" == typeof (r = arguments[s - 1]) && r && s--, 2 === s && (l = arguments[1])))
                for (var i = 0; i < n.entries.length; i++) {
                    if ((a = n.entries[i])[0] === e && a[1] === l) {
                        n.delete(e, l);
                        break;
                    }
                }
            else if (t(e))
                for (i = 0; i < n.entries.length; i++) {
                    if ((a = n.entries[i])[0] === e) {
                        n.delete(e);
                        break;
                    }
                }
            else if (e.length)
                e.forEach((e) => {
                    e && (Array.isArray(e) ? n.delete(e[0], e[1]) : n.delete(e));
                });
            else
                for (i = n.entries.length - 1; i >= 0; i--) {
                    var a,
                        o = (a = n.entries[i])[0];
                    if (e.hasOwnProperty(o)) {
                        var l = e[o];
                        a[1] === l && n.delete(o, l);
                    }
                }
            return r || (r = {}), U(n.toString(), r.replace, r.force, this);
        },
    }),
        (usf.Query = k);
    function L() {}
    L.prototype = {
        get term() {
            return V.get(b.termVar, "");
        },
        set term(e) {
            var t = {};
            (t[b.termVar] = e), V.update(t, [/uff_.*/, /usf_.*/, "page"], { force: !0 });
        },
        getTermQuery: (e) => b.termVar + "=" + encodeURIComponent(e),
        get page() {
            return parseInt(V.get("page")) || 1;
        },
        set page(e) {
            if (e <= 1) V.remove("page");
            else {
                var t = {};
                (t.page = e), V.add(t);
            }
        },
        get take() {
            return parseInt(V.get("usf_take")) || i.search.itemsPerPage;
        },
        set take(e) {
            e ? ((v = {}), (v.usf_take = e), V.update(v)) : V.remove("usf_take");
        },
        get skip() {
            return parseInt(V.get("usf_skip"));
        },
        set skip(e) {
            e ? ((v = {}), (v.usf_skip = e), V.update(v)) : V.remove("usf_skip");
        },
        resetPagination() {
            V.remove(["usf_take", "usf_skip"]);
        },
        get itemsPerPage() {
            return (function (e, t) {
                var r = parseInt(e) || t;
                r > t && (r = t);
                return r;
            })(V.get("usf_ipp"), i.search.itemsPerPage);
        },
        getPageUrl(e) {
            if (this.p === this.page) return "javascript:void(0)";
            var t = new URL(window.location.href),
                r = t.searchParams;
            return !e || e <= 1 ? r.delete("page") : r.set("page", e), t.toString();
        },
        get facetFilters() {
            var e,
                t = {};
            return (
                V.entries().forEach((r) => {
                    var n = r[0];
                    if (n.startsWith("uff_")) {
                        var s = "uff_".length,
                            i = n.indexOf("_", s),
                            a = n.substring(s, i);
                        a = parseInt(a, 36);
                        var o = n.substr(i + 1),
                            l = r[1];
                        Array.isArray(l) || (l = [l]), (t[a] = [o, l]), (e = !0);
                    }
                }),
                e ? t : null
            );
        },
        set facetFilters(e) {
            if (Object.keys(e).length) {
                var t,
                    r = {};
                for (var n in e) {
                    var s = e[n];
                    r["uff_" + ((t = n), parseInt(t).toString(36)) + "_" + s[0]] = s[1];
                }
                V.update(r, [/uff_.*/, "page"]);
            } else this.removeAllFacetFilters();
        },
        get view() {
            return V.get("usf_view", "grid");
        },
        set view(e) {
            if (e) {
                var t = {};
                (t.usf_view = e), V.add(t);
            } else V.remove("usf_view");
        },
        isViewChanged: (e) => 1 !== e.length || "usf_view" !== e[0][0],
        get sort() {
            var e = V.get("usf_sort");
            if (e) return e;
            var t = i.search.sortFields;
            return t ? t[0] : "";
        },
        set sort(e) {
            if (e) {
                var t = {};
                (t.usf_sort = e), V.add(t);
            } else V.remove("usf_sort");
        },
        removeAllFacetFilters() {
            V.remove([/uff_.*/, "page"]);
        },
    };
    var x = new L();
    usf.queryRewriter = x;
    var I = function (e) {
        if (((this.plugins = []), e)) for (var t = 0; t < e.length; t++) this.push(e[t]);
    };
    function R(e, t, r) {
        var n, s, i;
        for (s = document.getElementsByTagName("link"), i = 0; i < s.length; i++) if (s[i].href.endsWith(e)) return !1;
        return (n = document.createElement("link")).setAttribute("rel", "stylesheet"), n.setAttribute("type", "text/css"), n.setAttribute("href", e), t && (n.onload = t), r && (n.onerror = r), document.head.appendChild(n), !0;
    }
    function A(e, t, r, n) {
        var s, i, a;
        for (i = document.getElementsByTagName("script"), a = 0; a < i.length; a++) {
            var o = i[a].src;
            if (o && o.endsWith(e)) return !1;
        }
        return (
            (s = document.createElement("script")).setAttribute("type", "text/javascript"),
            s.setAttribute("src", e),
            (s.async = !0),
            n &&
                Object.keys(n).forEach(function (e) {
                    s.setAttribute(e, n[e]);
                }),
            t && (s.onload = t),
            r && (s.onerror = r),
            document.head.appendChild(s),
            !0
        );
    }
    function F(e, t, r, n) {
        for (var s = 0, i = 0, a = 0; a < t.length; a++) {
            var o,
                l = t[a];
            n ? (0, (o = A)) : (o = R),
                l.startsWith("http") || l.startsWith("//") || (l = e + l),
                o(l, function () {
                    ++s === i && r();
                }) && i++;
        }
        i === s && r();
    }
    function q(e, t) {
        for (; e; ) {
            if (!e || e === document.body) return;
            if ((e = e.parentNode) && e.classList.contains(t)) return e;
        }
    }
    function N(e, t, r, n) {
        if (!e) throw new Error("Element must be set.");
        if (e.length) for (var s = 0; s < e.length; s++) N(e[s], t, r, n);
        else if ((e._r_events || (e._r_events = {}), "string" == typeof t))
            r &&
                (n || (n = {}),
                (function (e, t, r, n) {
                    var s,
                        i = e._r_events[t];
                    i || (e._r_events[t] = i = []);
                    (s = function (t) {
                        return r.call(e, t);
                    }),
                        e.addEventListener(t, s, n),
                        (i[i.length] = { handler: r, browserHandler: s, options: n });
                })(e, t, r, n));
        else
            for (var i in t) {
                N(e, i, t[i], r);
            }
    }
    function j(e) {
        "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", e) : e();
    }
    function B(e) {
        H && ((H = []), delete H), n.raise("is_hide", e);
    }
    function M(e, t) {
        $(function () {
            !(function (e, t) {
                if (q(e, "usf-sr-inputbox") && usf.platform.collection) return;
                (t || e.value) && n.raise("is_show", e);
            })(e, t);
        });
    }
    (I.prototype = {
        push(e) {
            this.plugins.push(e);
        },
        invoke(e, t) {
            return (function e(t, r, n, s) {
                if (!(r >= t.length)) {
                    var i = t[r],
                        a = i[n];
                    if (a) {
                        var o = s.slice(0, s.length);
                        return (
                            o.push(function () {
                                if (r < t.length - 1) return e(t, r + 1, n, s);
                            }),
                            a.apply(i, o)
                        );
                    }
                    return e(t, r + 1, n, s);
                }
            })(this.plugins, 0, e, t);
        },
        has(e) {
            for (var t = this.plugins, r = 0; r < t.length; r++) if (t[r][e]) return !0;
        },
    }),
        (usf.plugins = new I(usf.plugins)); /* Begin plugin code */
					  
					
								
					  
								 
														  
							
													   
																  
						   
							
					  
			 
					   
		  
	   
    /* End plugin code */
    (usf.utils = {
        on: N,
        off: function (e, t, r) {
            if (e._r_events && t) {
                var n = null,
                    s = e._r_events[t] || [];
                if (void 0 !== r) {
                    for (var i = 0, a = s.length; i < a; i++)
                        if (s[i].handler === r) {
                            n = s[i].browserHandler;
                            break;
                        }
                    e.removeEventListener(t, n), s.splice(i, 1);
                } else if ("string" == typeof t) {
                    for (i = 0, a = s.length; i < a; i++) (n = s[i].browserHandler), e.removeEventListener(t, n);
                    delete e._r_events[t];
                } else
                    for (var o in t) {
                        for (r = t[o], i = 0, a = (s = e._r_events[o] || []).length; i < a; i++)
                            if (s[i].handler === r) {
                                n = s[i].browserHandler;
                                break;
                            }
                        e.removeEventListener(o, n), s.splice(i, 1);
                    }
            }
        },
        closest: q,
        loadJsFile: A,
        loadFiles: F,
        ready: j,
        installSearchInput: G,
        hideInstantSearch: B,
        loadAndShowInstantSearch: M,
        stopEvent: (e, t) => !!e && (e.preventDefault && e.preventDefault(), t || (e.stopPropagation && e.stopPropagation(), (e.cancelBubble = !0)), (e.returnValue = !1), !1),
        send(e, t) {
            var n = e.startTime || new Date().getTime();
            if (!e._errorModified) {
                var s = 6e3,
                    i = e.error;
                (e.timeout = s),
                    (e._errorModified = 1),
                    (e.error = function (r) {
                        var a;
                        if (new Date().getTime() - n >= s)
                            return (e.url = (a = e.url).includes("fallback") ? a : a.replace(/svc-(\d+)-/, "svc-$1-fallback-")), delete e.timeout, setTimeout(() => usf.utils.send.apply(this, [e, t]), 200), void (s = 1500);
                        i.apply(this, arguments);
                    });
            }
            if (!t) {
                var a = usf.plugins.invoke("send", [e]);
                if (void 0 !== a) return a;
            }
            return r(e);
        },
    }),
        (usf.fetch = y),
        (usf.query = new k(i.search.canChangeUrl));
    var W,
        D,
        H,
        V = usf.query;
    function J(e) {
        if (!e.target._usf_no_popup) {
            var t = e.target;
            t.value ? M(t) : B(t);
        }
    }
    function G(e, t) {
        if (e) {
            var r = i.instantSearch.online,
                n = i.search.online;
            if (r || n) {
                var s = e.parentNode;
                if (!s.classList.contains("usf-sr-inputbox")) {
                    var a = e.cloneNode(!0);
                    s.replaceChild(a, e), (e = a);
                }
                for (; "FORM" !== s.tagName; )
                    if ((s = s.parentNode) === document.body) {
                        s = null;
                        break;
                    }
                if (
                    ((W = b.baseUrl + i.search.searchResultsUrl),
                    s &&
                        (n && (s.action = W),
                        (s.onsubmit = function (t) {
                            var r = window.usf_container;
                            return location.pathname.includes(W) || (r && q(e, "usf-sr-inputbox")) ? ((x.term = e.value), r && r.click(), B(e)) : (location = W + "?" + b.termVar + "=" + encodeURIComponent(e.value)), usf.utils.stopEvent(t);
                        })),
                    (e._usf_no_popup = t),
                    e.setAttribute("autocomplete", "off"),
                    r)
                ) {
                    var o = t
                        ? null
                        : function (e) {
                              if (usf.isMobile) return M(e.target, !0), usf.utils.stopEvent(e);
                              M(e.target);
                          };
                    N(e, {
                        input: J,
                        keydown: function (e) {
                            13 === e.keyCode && (usf.utils.stopEvent(e), s ? s.onsubmit() : (location = W + "?q=" + encodeURIComponent(e.target.value)));
                        },
                        click: o,
                        focus: o,
                    });
                }
            }
        }
    }
    function $(e) {
        if (2 !== D)
            if (1 !== D) {
                var t;
                D = 1;
                var r = [(t = _usfTheme.assetUrl.replace("usf-boot.js", "{0}")).replace("{0}", "usf.js")],
                    s = [t.replace("{0}", "usf.css")];
                n.raise("preinit"),
                    b.init(),
                    e || y({ _refreshTime: new Date().getTime(), term: x.term, itemsLoaded: 0, itemsPerPage: x.itemsPerPage, page: x.page, take: x.take, facetFilters: x.facetFilters, sortBy: x.sort }, !1, !0),
                    F(
                        t,
                        r,
                        function () {
                            (D = 2),
                                H && (H.forEach((e) => e()), delete H),
                                (W = b.baseUrl + i.search.searchResultsUrl),
                                e && e(),
                                j(function () {
                                    n.raise("init");
                                    var e = document.body.classList;
                                    document.body.addEventListener("keyup", function (t) {
                                        9 == t.keyCode && e.add("usf-wc");
                                    }),
                                        document.addEventListener("click", function (t) {
                                            e.remove("usf-wc");
                                        });
                                });
                        },
                        1
                    ),
                    F(t, s, function () {}, 0);
            } else e && (H || (H = []), H.push(e));
        else e && e();
    }
    if (i.online) {
        var z = location.pathname,
            K = b.isCollectionPage ? i.collections.online : -1 !== z.indexOf(i.search.searchResultsUrl) && i.search.online;
        K && $(),
            j(function () {
                var e = document.body.classList;
                (usf.isMobile = document.body.clientWidth < i.mobileBreakpoint) && e.add("usf-mobile"),
                    window.usf_container && (K || $(), e.add("usf-has-container"), b.isCollectionPage && e.add("usf-collections-page"), e.add(i.filters.horz ? "usf-horz-layout" : "usf-vert-layout")),
                    i.instantSearch.searchBoxSelector.split(",").forEach((e) => {
                        for (var t = document.body.querySelectorAll(e), r = 0; r < t.length; r++) G(t[r]);
                    });
            });
    }
})();
